export default __webpack_public_path__ + "static/media/property_556.d4cd28fe.png";